import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { AllocationService } from 'src/app/_services/resource-allocation/allocation.service';
import { DatePipe } from '@angular/common';
import { UserService } from 'src/app/_services/user/user.service';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service';

@Component({
  selector: 'app-onboarding-it',
  templateUrl: './onboarding-it.component.html',
  styleUrls: ['./onboarding-it.component.scss']
})
export class OnboardingItComponent implements OnInit {
  tenantId: string;
  usersForm;
  userCreationForm;
  isHRAdmin: boolean;
  isITAdmin: boolean;
  userDetails: any;
  requester: any;
  TodayDate: string;
  date: any;
  userCreationId: any;
  userFullName: any;

  constructor(
    private router: Router,
    private storageService: LocalStorageService,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private allocationService: AllocationService,
    private userService: UserService,
    private datePipe: DatePipe,
    private snackBar: MatSnackBar
  ) {
    this.usersForm = this.formBuilder.group({
      id: new FormControl(''),
      userId: new FormControl('', [ Validators.required ] ),
      password: new FormControl('', Validators.required),
      firstName: new FormControl('', Validators.required),
      lastName: new FormControl('', Validators.required),
      displayName: new FormControl('', Validators.required),
      department: new FormControl('', Validators.required),
      phoneNo: new FormControl(''),
      location: new FormControl(''),
      joinDate: new FormControl(''),
      permanentOrContractor: new FormControl(''),
      alternateEmailId: new FormControl('', Validators.required),
      supervisorId: new FormControl(''),
      supervisonName: new FormControl('', Validators.required),
      currentDesignation: new FormControl(''),
      careerStartDate: new FormControl(''),
      middleName: new FormControl(''),
      managerId: new FormControl(''),
      managerName: new FormControl(''),
      addedToBioMetrics: new FormControl(''),
      totalExperience: new FormControl(''),
      currentExperience: new FormControl(''),
      localId: new FormControl(''),
      biometric: new FormControl(''),
      birthDate: new FormControl('')
    })
    this.userCreationForm = this.formBuilder.group({
      id: new FormControl(''),
      requesterId: new FormControl({value:'' , disabled: true}),
      requesterName: new FormControl({value:'' , disabled: true}),
      requestedDate: new FormControl({value:'' , disabled: true}),
      status: new FormControl({value:'' , disabled: true}),
      userId: new FormControl({value:'' , disabled: true}),
      firstName: new FormControl({value:'' , disabled: true}),
      middleName: new FormControl({value:'' , disabled: true}),
      lastName: new FormControl({value:'' , disabled: true}),
      emailId: new FormControl({value:'' , disabled: true}),
      remarks: new FormControl({value:'' , disabled: true}),
      addedToBioMetrics: new FormControl({value:'' , disabled: true}),
      licenseType: new FormControl({value:'' , disabled: true}),
      licenseRequired: new FormControl({value:'' , disabled: true}),
      licenseAllocation: new FormControl({value:'' , disabled: true}),
      systemRequiredBoolean: new FormControl({value:'' , disabled: true}),
      systemRequired: new FormControl({value:'' , disabled: true}),
      ndaSignedDate: new FormControl({value:'' , disabled: true}),
      biometric: new FormControl({value:'' , disabled: true}),
      ismsTraining: new FormControl({value:'' , disabled: true}),
      ismsAgreement: new FormControl({value:'' , disabled: true}),
      passwordBoolean: new FormControl({value:'' , disabled: true}),
      localId: new FormControl({value:'', disabled: true}),
      emailIdRequired: new FormControl({value:''}),
      ndaSignedBoolean: new FormControl({value:''}),
      domainUserId: new FormControl({value:''})
    });
  }

  ngOnInit(): void {
    this.tenantId = this.storageService.get('tenantId');
    this.userDetails = JSON.parse(this.storageService.get('currentUser'));

    this.requester = this.userDetails.id + " . " + this.userDetails.firstName + " " + this.userDetails.lastName;
    this.date = new Date();
    let latest_date = this.datePipe.transform(this.date, 'yyyy-MM-dd');
    this.TodayDate = latest_date;

    this.userCreationForm.value.requesterId = this.requester;
    this.userCreationForm.value.requestedDate = this.TodayDate;
    this.userCreationForm.patchValue(this.userCreationForm.value);

    this.isHRAdmin = this.userDetails.admin || this.userDetails.roles.includes('RoleHrmAdministrator') ;
    this.isITAdmin = this.userDetails.admin || this.userDetails.roles.includes('RoleITAdministrator') ;

    this.userCreationId = this.route.snapshot.paramMap.get('id');
    console.log("userCreationId", this.userCreationId)
    if (this.userCreationId) {
      this.getUserCreationById(this.userCreationId);
    }
  }

  getUserCreationById(id){
    this.userService.getUserCreationById(id).subscribe((response) => {
      console.log("response",response);
      if (response) {
        this.userCreationForm.patchValue({
          requesterId: response.requesterId + " . " + response.requesterName,
          requestedDate: response.requestedDate,
          userId: response.userId + " . " + response.firstName + " " + response.lastName,
          status: response.status,
          remarks: response.remarks,
          addedToBioMetrics: response.addedToBioMetrics,
          licenseType: response.licenseType,
          licenseRequired: response.licenseRequired,
          ismsTraining: response.ismsTraining,
          passwordBoolean: response.passwordBoolean,
          biometric: response.biometric,
          domainUserId: response.domainUserId
        })
      }

      let userId = response.userId;
      this.userService.getUser(userId).subscribe((response) => {
        this.userFullName = response.firstName + " "+ response.middleName + " " + response.lastName;
        this.usersForm.patchValue({
          userId: response.userId,
          localId: response.localId,
          password: response.password,
          firstName: response.firstName,
          middleName: response.middleName,
          lastName: response.lastName,
          displayName: response.displayName,
          department: response.department,
          alternateEmailId: response.alternateEmailId,
          phoneNo: response.phoneNo,
          location: response.location,
          joinDate: response.joinDate,
          permanentOrContractor: response.permanentOrContractor,
          supervisonName: response.supervisorId + ' . ' + response.supervisonName,
          currentDesignation: response.currentDesignation,
          archived: true,
          managerName: response.managerName,
          birthDate: response.birthDate,
        });
        this.userCreationForm.value.emailId = response.emailId;
        this.userCreationForm.value.localId = response.localId;
        this.userCreationForm.patchValue(this.userCreationForm.value);
      })
    })
  }

  get f() {
    return this.usersForm.controls;
  }

  openItonboarding() {
    this.router.navigate([this.tenantId + '/dashboard/hr/onboarding-component/onboarding-it', {id: this.userCreationId}]);
  }

  openHrmonboarding() {
    this.router.navigate([this.tenantId + '/dashboard/hr/onboarding-component/onboarding-form', {id: this.userCreationId}]);
  }

  openndaonboarding() {
    this.router.navigate([this.tenantId + '/dashboard/hr/onboarding-component/onboarding-nda', {id: this.userCreationId}]);
  }

  backToOnboarding(){
    this.router.navigate([ this.tenantId + '/dashboard/hr/onboarding-component/onboarding' ]);
  }
}
